<template>
  <div id="app">
    <nav class="navbar navbar-dark bg-primary">
      <div class="container-fluid">
        <div class="nav-title">
          <h1 class="navbar-brand">連携医療機関検索サイト</h1>
        </div>
        <div class="d-flex">
          <div>
            <img src="\NCC_A_3l_left_2c.jpg" class="logo-img" alt="logoimg" />
          </div>
        </div>
      </div>
    </nav>

    <b-container>
      <ListInsts />
    </b-container>

    <footer id="sticky-footer" class="flex-shrink-0 py-2 mb-0 bg-primary text-white">
      <div class="container text-center">
        <small>Copyright &copy; National Cancer Center All Rights Reserved.</small>
      </div>
    </footer>
  </div>
</template>

<script>
import ListInsts from "./components/ListInsts.vue";

export default {
  name: "App",
  components: {
    ListInsts,
  },
};
</script>

<style lang="scss">
@import "./assets/styles/mycustom.scss";
@import "../node_modules/bootstrap/scss/bootstrap.scss";

#app {
  font-size: 1em;
}

.nav-title {
  margin-left: 30px;
}

.logo-img {
  margin-right: 40px;
  max-width: 240px;
  height: auto;
}
</style>
